module.exports = __webpack_public_path__ + "img/body_red.4497cb77.png";